// src/components/Sidebar.js

import React from 'react';
import { Link } from 'react-router-dom';
import {
  HomeIcon,
  CalculatorIcon,
  DocumentTextIcon,
  InformationCircleIcon,
  ChatBubbleLeftEllipsisIcon,
  CreditCardIcon,
  CogIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';

const getIconComponent = (text) => {
  const icons = {
    Home: <Squares2X2Icon className="h-5 w-5" />,
    'Nest Overview': <InformationCircleIcon className="h-5 w-5" />,
    'Estimate Price': <CalculatorIcon className="h-5 w-5" />,
    'Valuations': <DocumentTextIcon className="h-5 w-5" />,
    'Properties': <HomeIcon className="h-5 w-5" />,
    'My Payments': <CreditCardIcon className="h-5 w-5" />,
    Support: <ChatBubbleLeftEllipsisIcon className="h-5 w-5" />,
    Blockchain: <CogIcon className="h-5 w-5" />,
  };
  return icons[text] || null;
};

const MenuItem = ({ text, link }) => {
  const IconComponent = getIconComponent(text);
  return (
    <li className="rounded transition-colors duration-300 hover:bg-yellow-500">
      <Link
        to={link}
        className="flex items-center p-2 text-white no-underline hover:no-underline"
      >
        {IconComponent && <span className="mr-2">{IconComponent}</span>}
        <span>{text}</span>
      </Link>
    </li>
  );
};

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <>
      {/* Overlay for Mobile Sidebar */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
          onClick={toggleSidebar}
          aria-hidden="true"
        ></div>
      )}

      {/* Sidebar */}
      <div
        className={`
          fixed top-16 left-0 bottom-0 w-52 bg-gray-800 text-white flex flex-col p-2
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          md:translate-x-0 md:static
          z-30
        `}
      >
        <ul className="list-none p-0 m-0 flex-grow mt-20">
          <MenuItem text="Home" link="/portal" />
          <li className="p-2 text-xs text-gray-400 mt-4">HOUSE VALUATIONS</li>
          <MenuItem text="Properties" link="/portal/properties" />
          {/* <MenuItem text="Valuations" link="/portal/quotes" />  */}
          <li className="p-2 text-xs text-gray-400 mt-4">SUPPORT</li>
          <MenuItem text="Support" link="/portal/support" />
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
